<template>
  <div>
    <profile-gallery v-if="showPrivacyProgress || isAdmin" :images="images" :isOwner="isOwner"/>
    <p v-if="!showPrivacyProgress && !isAdmin">User has chosen to keep their gallery private</p>
  </div>
</template>

<script>
  import ProfileGallery from "../../components/Profile/Gallery/Gallery";
  import ProfileMixin from "../../mixins/ProfileMixin";
  
  export default {
    mixins: [
      ProfileMixin
    ],
    components: {ProfileGallery},
    data() {
      return {
        images: []
      }
    },
    mounted() {
      let self = this;
      self.images = self.getProfile().gallery;
    }
  }

</script>



// WEBPACK FOOTER //
// ProfileGallery.vue?53b2c706